// Which geographic scopes each universe makes available
export const UNIVERSE_SCOPES: Record<string, Array<string>> = {
  P000000050: ['north_america', 'dev_ex_na', 'emerging'], // Global Markets — all scopes
  '1911833.0': ['north_america'], // US Target Market Exposure
  '2499059.0': ['north_america'], // US Market Extended
  '2575855.0': ['north_america'], // Canada Domestic (part of NA)
  P000001109: ['dev_ex_na'], // Developed Markets ex-NA
  P000000112: ['emerging'], // Emerging Markets
};

export const GEOGRAPHIC_SCOPES = [
  { id: 'global', label: 'Global', hidden: true },
  { id: 'north_america', label: 'North America', hidden: false },
  { id: 'dev_ex_na', label: 'Developed Markets (ex-NA)', hidden: false },
  { id: 'dev_ex_us', label: 'Developed Markets (ex-US)', hidden: true },
  { id: 'emerging', label: 'Emerging Markets', hidden: false },
];

/** Look up a human-readable label for a geographic scope ID or raw string. */
export const SCOPE_LABEL_MAP = new Map(
  GEOGRAPHIC_SCOPES.map((s) => [s.id, s.label]),
);

export function formatScopeLabel(scope: string): string {
  return SCOPE_LABEL_MAP.get(scope) ?? scope;
}

export const VISIBLE_SCOPES = GEOGRAPHIC_SCOPES.filter((s) => !s.hidden);

export const SIZE_SEGMENTS = [
  { id: 'large', label: 'Large Cap' },
  { id: 'mid', label: 'Mid Cap' },
  { id: 'small', label: 'Small Cap' },
];

export const CYCLICALITY = [
  { id: 'cyclical', label: 'Cyclical' },
  { id: 'defensive', label: 'Defensive' },
  { id: 'sensitive', label: 'Sensitive' },
];

// Market bucket for the "Market" filter — derived from an index's coverage
// label, matching the Figma's Global / Developed / Emerging grouping. Shared by
// the universe index picker AND the benchmark picker (both list the same
// Morningstar indices) so their filter bars are identical — do not fork.
export const MARKET_ORDER = [
  'Global Markets',
  'Developed Markets',
  'Emerging Markets',
];
export function marketOf(coverageLabel: string | undefined): string {
  if (coverageLabel === 'Global Markets') return 'Global Markets';
  if (coverageLabel === 'Emerging Markets') return 'Emerging Markets';
  return 'Developed Markets';
}
